import { render } from "./List.vue?vue&type=template&id=0f60c48e&scoped=true&ts=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=0f60c48e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f60c48e"]])

export default __exports__